interface ContactEntity {
	_id?: string
	status: Status
	fullname: string
	phone: number
	email: string
	message: string
	response?: string
	_created?: Date
	_modified?: Date
	_deleted?: boolean
}

enum Status {
	pendding = 'pending',
	viewed = 'viewed',
}

export type { ContactEntity }
export { Status}